module.exports = new __parcel__URL__("global-issue-navigator-skeleton.tpl.b1bf4b99.svg").toString();